import { render, staticRenderFns } from "./LivePrices.vue?vue&type=template&id=11d7715a&scoped=true"
import script from "./LivePrices.vue?vue&type=script&lang=js"
export * from "./LivePrices.vue?vue&type=script&lang=js"
import style0 from "./LivePrices.vue?vue&type=style&index=0&id=11d7715a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d7715a",
  null
  
)

export default component.exports